import requestCountry from 'js/lib/requestCountry';

import authenticationEpicClient from 'bundles/epic/clients/authentication';

// Utility function to determine when to show the terms of use acceptance flow this is for all US users
export const isTermsOfUseRolloutForUS = () => {
  return requestCountry.get() === 'US' && authenticationEpicClient.preview('enableTermsOfUseAcceptance');
};

// Utility function to check if the legal consolidation auth flow should be shown to the user
export const shouldShowLegalConsolidationAuthFlow = () => {
  return requestCountry.get() === 'US' && authenticationEpicClient.preview('enableLegalConsolidationAuthFlow');
};

// Utility function to check if the checkbox terms of use should be shown in the signup form
export const shouldShowCheckboxTermsOfUse = () => {
  return !shouldShowLegalConsolidationAuthFlow() && isTermsOfUseRolloutForUS();
};

export const generateImpressionForEnableLegalConsolidationAuthFlow = () =>
  authenticationEpicClient.get('enableLegalConsolidationAuthFlow');

export default {
  shouldShowCheckboxTermsOfUse,
  isTermsOfUseRolloutForUS,
};
